<template>
    <div>
        <audio id="audio" :src="'../static/music/music.mp3'" autoplay="autoplay" loop preload="auto"></audio>
        <div class="footer" v-if="show">
            <div class="box" v-for='(item,index) of newitems' :key = "index" :class='[item.cls,{on:index === idx}]'  @click.stop="change(item.push,index)">
                <div >
                    <img v-bind:src="'../static/images/caidan/'+item.icon+item.icon_unclick+'.png '">
                </div>
                <p :class="['colorChange',{on:index===idx}]" >{{item.name}}</p>
                <!--:class="item.icon"-->
            </div>
        </div>
        <div class="menuUp" v-bind:class="{am:isAnim}">
        <ul class = "ul_S" >
            <div class="box" v-for='(item,index) of newitems_up' :key = "index" :class='[item.cls,{on:index === idx}]'  @click.stop="change_up(item.push,index)">
                <div >
                    <img v-bind:src="'../static/images/caidan/'+item.icon+item.icon_unclick+'.png '">
                </div>
                <p >{{item.name}}</p>
                <!--:class="item.icon"-->
            </div>
        </ul>
        <div class="iw-menu-board-split"></div>
        <div class="iw-button">
            <div type="iw-icon-music" class="iw-icon-music" iw-click="audio" iw-clk-param="background" is_on="false" style="display: block;">
                <img :src="'../static/images/system/gps.png'" @click="map()" alt="">
            </div>
            <div type="iw-icon-gps" class="action iw-icon-gps"  is_on="true">
                <img :src="'../static/images/system/music-action.png'" @click="show_music($event)" alt="">
            </div>
            <div type="iw-icon-phone" class="action iw-icon-phone"  is_on="true">
                <img :src="'../static/images/system/copyright-action.png'" @click="drawer = true"  alt="">
            </div>
        </div>
        </div>

<!--        <div class="menuTop">
            <div class="user_logo">
                <img :src="'../static/images/system/QH_LOGO.jpg'" alt="">
            </div>
            <div class="user-info">
                <span class="userinfo-name">学府清华</span>
                <span class="userinfo-phone">0316-5926868</span>
            </div>
            <div class="btn-content">
                <a href="tel:0316-5926868" class="btn">
                    <button class="btn-phone"></button>
                </a>
                &lt;!&ndash;<button class="btn-phone"></button>&ndash;&gt;
                <hr>
            </div>
        </div>-->

        <el-dialog
                title=" "
                :visible.sync="drawer"
                :fullscreen ="true"
                :modal="false"
                :append-to-body="true"
                :lock-scroll="false"
                :width="'100%'">
            <div>
                <img style="width: 100%;height: 100%;" :src="'../static/images/BQ.png'" alt="">
            </div>
        </el-dialog>

    </div>

</template>

<script type="text/javascript">
    export default{
        name: 'bottomnav',
        // props:['idx'],
        data(){
            return {
                isPlaying:true,
                activeName: 'second',
                drawer: false,
                direction: 'btt',
                show:true,
                idx:0,
                isAnim: false,
                items:[
                {
                    cls:"sand",
                    name:"三维沙盘",
                    icon_unclick:2,
                    push:"/sand",
                    icon:"1-WSP"
                },
                {
                    cls:"Location",
                    name:"区位交通",
                    icon_unclick:1,
                    push:"/Location",
                    icon:"2-jt"
                },
                {
                    cls:"hardcover",
                    name:"样板间VR",
                    icon_unclick:1,
                    push:"/hardcover",
                    icon:"4-JZ"
                },
                {
                    cls:"Distribution",
                    name:"户型鉴赏",
                    icon_unclick:1,
                    push:"/Distribution",
                    icon:"6-HX"
                },

                {
                     cls:"user",
                     name:"更多",
                     icon_unclick:1,
                     push:"/user",
                     icon:'5-GD'
                },

                {
                    cls:"roam",
                    name:"园林漫游",
                    icon_unclick:1,
                    push:"/roam",
                    icon:"3-JG"
                },
                {
                    cls:"Massif",
                    name:"集团介绍",
                    icon_unclick:1,
                    push:"/Brand_JT",
                    icon:"7-DT",
                },
                {
                    cls:"Brand",
                    name:"电子楼书",
                    icon_unclick:1,
                    push:"/Brand",
                    icon:"8-PP",
                },
                ]
            }
        },
        mounted(){
            this.$nextTick(() => {
                var state = 0;
                var music = document.getElementById('audio');
                document.addEventListener('touchstart', () => {
                    if(state===0){
                        music.play();
                        state=1;
                        console.log("duaio");
                    }
                },false);

                document.addEventListener("WeixinJSBridgeReady", function () {
                    music.play();
                    console.log("music");
                }, false);

            });


          this.items.forEach((e,i)=>{
              if (this.$route.path===e.push){
                  this.idx=i
              }
            });
        var paths=['/sand','/location','/roam','/hardcover','/user','/Distribution','/Brand','/Brand_JT','/Massif'];
        if (paths.indexOf(this.$route.path)>-1){
            this.show=true
        }else {
            //this.show=false
        }
        },
        watch:{
            $route(to,from){
                var paths=['/sand','/location','/roam','/hardcover','/user','/Distribution','/Brand','/Brand_JT','/Massif'];
                if (paths.indexOf(to.path)>-1){
                    this.show=true
                }else {
                    //this.show=false
                }
            }
        },
        computed: {
            newitems: function () {
                return this.items.filter(function (items,index) {
                    return index <= 4;
                })
            },
            newitems_up: function () {
                return this.items.filter(function (items,index) {
                    return index > 4;
                })
            }
        },
        methods:{
            // drag:function(event){    //接收事件对象
            //     dom = event.currentTarget;
            // },
            show_music(e){
                var audio=document.querySelector('#audio');
                if(this.isPlaying){
                    e.target.src="../static/images/system/music-disable.png";
                    console.log(e.target.src);
                    audio.pause();
                }else{
                    e.target.src="../static/images/system/music-action.png";
                    audio.play();
                }
                this.isPlaying=!this.isPlaying;
            },
            map(){
                this.$router.push('map');
                this.isAnim =false;
            },
            startbottom() {
                this.isAnim = !this.isAnim
                /*console.log("item")*/
            },
            change_up(push,index){

               /* var arr = this.items[3];
                this.items[3]=this.items[index+5];
                console.log(arr);
                console.log(this.items[index+5]);
                this.items[index+4] = arr;*/

               /*用Splice才能触发重新计算数值*/
                var arr = this.items.splice(3,1,this.items[index+5])[0];
                /*console.log(this.items[index+5]);*/
                this.items.splice([index+5],1,arr);
/*              this.newitems = this.items.filter(function(items,index) {
                    return index <= 4;
                });
                this.newitems_up = this.items.filter(function(items,index) {
                    return index > 4;
                });*/
                /*console.log(this.newitems);*/

                //this.$router.push(push);
                this.$router.push({
                    path: push,
                    query: {
                        hxTo:false,
                        ID_visible: true
                    }
                });
                this.isAnim =false;

                this.idx=3;

                this.newitems[3].icon_unclick=2;

            },

            change(push,index){
                if(index==4) {
                    this.$router.push({
                        query: {
                            hxTo:false,
                            ID_visible: false
                        }
                    });
                    this.startbottom();
                }
                else {
                    this.$router.push({
                        path: push,
                        query: {
                            hxTo:false,
                            ID_visible: true
                        }
                    });
                    console.log(this.$router);
                    this.isAnim =false;
                }
                this.idx=index;

                for (var i=0;i<this.items.length;i++) {
                    if(i==index){
                        this.items[i].icon_unclick=2;
                }else{
                        this.items[i].icon_unclick=1;
                    }

                }
            }
        }

    }

</script>
<style lang="scss" scoped>
    .footer{
        /*border-radius: 8px;*/
        display: flex; justify-content: space-between;
        position: absolute;
        left: 0;
        bottom:-4px;
        padding:4px 20px 8px 20px;
        /*background: url("../../static/images/caidan/dt.png")no-repeat;*/
        background-color: rgba(31, 21, 5, 0.80);
        background-size: 100%;
        width: 100%;
        height:60px;
        z-index:99;
    }
    .menuTop{
        display: flex;
        justify-content: space-between;
        position: absolute;
        left: 0;
        top:-4px;
        padding:4px 20px 8px 20px;
        /*background: url("../../static/images/caidan/dt.png")no-repeat;*/
        background-color: rgba(31, 21, 5, 0.80);
        background-size: 100%;
        width: 100%;
        height:40px;
        z-index:99;
    }
    .user_logo{
        left: -5px;
        top:3px;
        width: 30px;
        height: 30px;
        border: 1px #edc789 solid;
        border-radius: 50%;
        background-repeat: no-repeat;
        position: relative;
    }
    .user_logo img{
        width: 28px;
        height: 28px;
        border-radius: 50%;
    }
    .user-info{
        display: block;
        left: 40px;
        top:5px;
        width: 200px;
        height: 40px;
        position: absolute;
    }
    .user-info>.userinfo-name {
        display: block;
        text-align:left;
        position: relative;
        padding: 0;
        margin: 0;
        color: #ffffff;
        font-size: 12px;
        top: 5px;
        left: 15px;
    }
    .user-info>.userinfo-phone {
        display: block;
        position: relative;
        text-align:left;
        padding: 5px;
        margin: 0;
        color: #ffffff;
        font-size: 10px;
        top: 1px;
        left: 0;
        transform: scale(0.9);
    }
    .btn-content {
        display: block;
        position: absolute;
        width: 70%;
        height: 40px;
        right: 0;
        top: 3px;
    }
    .btn-content>hr {
        display: block;
        float: right;
        width: 1px;
        height: 50px;
        background-color: #1e1e1e;
        padding: 0;
        margin: 0;
        margin-top: -4px;
        transform: scale(0.3);
        transform-origin: left center;
    }
    .btn-content button {
        display: block;
        float: right;
        overflow: hidden;
        border: 0;
        border-width: 0;
        width: 32px;
        height: 32px;
        background: url('../../static/images/system/button_phone.png');
        background-size: cover;
        /* transform: scale(0.9); */
        margin: 0;
        margin-top: 4px;
        margin-left: 5px;
        margin-right: 5px;
    }
   .box{
       cursor: pointer;
       flex: 1;
       margin: auto;
       padding:5px;
/*       width: 20%;*/
      /* height: 100%;*/
       font-size: 1.2rem;
       color: #555454;
       text-align: center;
       -webkit-user-select: none;
       -moz-user-select: none;
       -ms-user-select: none;
       user-select: none;
       -webkit-tap-highlight-color: transparent;
    }
    .menuUp .iw-button {
        //border-radius: 8px 8px 0 0;
        margin: auto;
        display: flex;
        justify-content: center;
        -moz-opacity:0.0;
        -khtml-opacity: 0.0;
        opacity: 1.0;
        width: 55%;
        background-color: rgba(31, 21, 5, 0.80);
        background-size: 100%;
        bottom:155px;
        height:40px;
    }
    .menuUp .iw-button>div {
        display: block;
        float: left;
        width: 26px;
        height: 30px;
        margin: 12px 22px;
        //padding: 5px;
    }
   img{
       width: 100%;
   }
    .box>div{
        margin: 0 auto 6px auto; width: 20px; height: 20px;
        font-size: 20px;
    }
    div p{
        color: #ffffff;
        font-size:12px;
        font-family: "微软雅黑";
    }
    .on{
        color:#edc789;
    }
    .menuUp {
        position: fixed;
        bottom: -100px;
        width: 100%;
        text-align: center;
        z-index:10;
        transition:bottom 1s;
        -webkit-transition:bottom 1s; /* Safari */
    }
    .menuUp .iw-menu-board-split {
        display: block;
        position: absolute;
        background: rgba(200, 200, 200, 0.8);
        width: 55%;
        height: 1px;
        left: 0;
        right: 0;
        top: 60px;
        transform: scale(1, 0.6);
        margin: auto;
    }
    .ul_S {
        border-radius: 8px 8px 0 0;;
        margin: auto;
        display: flex;
        justify-content: space-between;
        /*position: absolute;*/
        /*left:0;*/
        -moz-opacity:0.0;
        -khtml-opacity: 0.0;
        opacity: 1.0;
        /*padding: 10px;*/
       /* margin-bottom:-10px;*/
        width: 55%;
        background-color: rgba(31, 21, 5, 0.80);
        background-size: 100%;
        bottom:155px;
        height:50px;
/*        transition:opacity 1s;
        -webkit-transition:opacity 1s; !* Safari *!*/
    }
    .am{
        bottom: 56px;
        /*height:100px;*/
        /*-moz-opacity:1.0;
        -khtml-opacity: 1.0;
        opacity: 1.0;*/
    }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue